/* tslint:disable */
import { Injectable } from '@angular/core';
import { SilverNonEmployeesLogonBaseService } from '../silver-non-employees-logon-base-service';
import { EnviromentService } from '@core/services/environment/environment.service';
import { SilverNonEmployeesLogonRequestBuilder } from '../silver-non-employees-logon-request-builder';
import { HttpService } from '@core/http/http.service';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ChangePasswordEndRequest } from '../models/change-password-end-request';
import { ChangePasswordEndResponse } from '../models/change-password-end-response';
import { ChangePasswordInitRequest } from '../models/change-password-init-request';
import { ChangePasswordInitResponse } from '../models/change-password-init-response';
import { LogonEndRequest } from '../models/logon-end-request';
import { LogonInitResponse } from '../models/logon-init-response';
import { LogonRequest } from '../models/logon-request';
import { LogonResponse } from '../models/logon-response';
import { RegisterEndRequest } from '../models/register-end-request';
import { RegisterEndResponse } from '../models/register-end-response';
import { RegisterInitRequest } from '../models/register-init-request';
import { RegisterInitResponse } from '../models/register-init-response';
import { RegisterStep2Request } from '../models/register-step-2-request';
import { RegisterStep2Response } from '../models/register-step-2-response';
import { SelectedPwdRequest } from '../models/selected-pwd-request';
import { SelectedPwdResponse } from '../models/selected-pwd-response';
import { VerifyOtpRequest } from '../models/verify-otp-request';
import { VerifyOtpResponse } from '../models/verify-otp-response';


/**
 * Silver Controller
 */
@Injectable({
  providedIn: 'root',
})
export class SilverControllerService extends SilverNonEmployeesLogonBaseService {
  constructor(
    config: EnviromentService,
    http: HttpService
  ) {
    super(config, http);
  }

  /**
   * Path part for operation changePwdEndUsingPost
   */
  static readonly ChangePwdEndUsingPostPath = '/silver/changePwdEnd';

  /**
   * Final step for changing password.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `changePwdEndUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePwdEndUsingPost$Response(params: {
  
    /**
     * changePasswordEndRequest
     */
    body: ChangePasswordEndRequest
  }): Observable<ChangePasswordEndResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.ChangePwdEndUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as ChangePasswordEndResponse;
      })
    );
  }

  /**
   * Final step for changing password.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `changePwdEndUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePwdEndUsingPost(params: {
  
    /**
     * changePasswordEndRequest
     */
    body: ChangePasswordEndRequest
  }): Observable<ChangePasswordEndResponse> {

    return this.changePwdEndUsingPost$Response(params).pipe(
      map(r => r as ChangePasswordEndResponse)
    );
  }

  /**
   * Path part for operation changePwdInitUsingPost
   */
  static readonly ChangePwdInitUsingPostPath = '/silver/changePwdInit';

  /**
   * Initial step for changin password.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `changePwdInitUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePwdInitUsingPost$Response(params: {
  
    /**
     * initialSignRequest
     */
    body: ChangePasswordInitRequest
  }): Observable<ChangePasswordInitResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.ChangePwdInitUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as ChangePasswordInitResponse;
      })
    );
  }

  /**
   * Initial step for changin password.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `changePwdInitUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePwdInitUsingPost(params: {
  
    /**
     * initialSignRequest
     */
    body: ChangePasswordInitRequest
  }): Observable<ChangePasswordInitResponse> {

    return this.changePwdInitUsingPost$Response(params).pipe(
      map(r => r as ChangePasswordInitResponse)
    );
  }

  /**
   * Path part for operation initialStepUsingPost
   */
  static readonly InitialStepUsingPostPath = '/silver/initialStep';

  /**
   * Initial step for client registration.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `initialStepUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  initialStepUsingPost$Response(params: {
  
    /**
     * initialStepRequest
     */
    body: RegisterInitRequest
  }): Observable<RegisterInitResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.InitialStepUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as RegisterInitResponse;
      })
    );
  }

  /**
   * Initial step for client registration.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `initialStepUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  initialStepUsingPost(params: {
  
    /**
     * initialStepRequest
     */
    body: RegisterInitRequest
  }): Observable<RegisterInitResponse> {

    return this.initialStepUsingPost$Response(params).pipe(
      map(r => r as RegisterInitResponse)
    );
  }

  /**
   * Path part for operation logonUsingPost
   */
  static readonly LogonUsingPostPath = '/silver/logon';

  /**
   * Step 1 for logon service.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `logonUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logonUsingPost$Response(params: {
  
    /**
     * logonRequest
     */
    body: LogonRequest
  }): Observable<LogonInitResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.LogonUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as LogonInitResponse;
      })
    );
  }

  /**
   * Step 1 for logon service.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `logonUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logonUsingPost(params: {
  
    /**
     * logonRequest
     */
    body: LogonRequest
  }): Observable<LogonInitResponse> {

    return this.logonUsingPost$Response(params).pipe(
      map(r => r as LogonInitResponse)
    );
  }

  /**
   * Path part for operation logonStepEndUsingPost
   */
  static readonly LogonStepEndUsingPostPath = '/silver/logonStepEnd';

  /**
   * Final step for logon service.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `logonStepEndUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logonStepEndUsingPost$Response(params: {
  
    /**
     * logonRequest
     */
    body: LogonEndRequest
  }): Observable<LogonResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.LogonStepEndUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as LogonResponse;
      })
    );
  }

  /**
   * Final step for logon service.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `logonStepEndUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logonStepEndUsingPost(params: {
  
    /**
     * logonRequest
     */
    body: LogonEndRequest
  }): Observable<LogonResponse> {

    return this.logonStepEndUsingPost$Response(params).pipe(
      map(r => r as LogonResponse)
    );
  }

  /**
   * Path part for operation registerEndUsingPost
   */
  static readonly RegisterEndUsingPostPath = '/silver/registerEnd';

  /**
   * Last step for client registration process.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `registerEndUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerEndUsingPost$Response(params: {
  
    /**
     * registerEndRequest
     */
    body: RegisterEndRequest
  }): Observable<RegisterEndResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.RegisterEndUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as RegisterEndResponse;
      })
    );
  }

  /**
   * Last step for client registration process.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `registerEndUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerEndUsingPost(params: {
  
    /**
     * registerEndRequest
     */
    body: RegisterEndRequest
  }): Observable<RegisterEndResponse> {

    return this.registerEndUsingPost$Response(params).pipe(
      map(r => r as RegisterEndResponse)
    );
  }

  /**
   * Path part for operation registerStep2UsingPost
   */
  static readonly RegisterStep2UsingPostPath = '/silver/registerStep2';

  /**
   * Step 2 for client registration.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `registerStep2UsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerStep2UsingPost$Response(params: {
  
    /**
     * registerStep2Request
     */
    body: RegisterStep2Request
  }): Observable<RegisterStep2Response> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.RegisterStep2UsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as RegisterStep2Response;
      })
    );
  }

  /**
   * Step 2 for client registration.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `registerStep2UsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerStep2UsingPost(params: {
  
    /**
     * registerStep2Request
     */
    body: RegisterStep2Request
  }): Observable<RegisterStep2Response> {

    return this.registerStep2UsingPost$Response(params).pipe(
      map(r => r as RegisterStep2Response)
    );
  }

  /**
   * Path part for operation selectPwdUsingPost
   */
  static readonly SelectPwdUsingPostPath = '/silver/selectPwd';

  /**
   * Selected password for client registration process.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `selectPwdUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selectPwdUsingPost$Response(params: {
  
    /**
     * selectPwdRequest
     */
    body: SelectedPwdRequest
  }): Observable<SelectedPwdResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.SelectPwdUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as SelectedPwdResponse;
      })
    );
  }

  /**
   * Selected password for client registration process.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `selectPwdUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selectPwdUsingPost(params: {
  
    /**
     * selectPwdRequest
     */
    body: SelectedPwdRequest
  }): Observable<SelectedPwdResponse> {

    return this.selectPwdUsingPost$Response(params).pipe(
      map(r => r as SelectedPwdResponse)
    );
  }

  /**
   * Path part for operation verifyOtpUsingPost
   */
  static readonly VerifyOtpUsingPostPath = '/silver/verifyOTP';

  /**
   * OTP verification for client registration.
   *
   *
   *
   * This method provides customization options.
   * To access only the response body, use `verifyOtpUsingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyOtpUsingPost$Response(params: {
  
    /**
     * verifyOtpRequest
     */
    body: VerifyOtpRequest
  }): Observable<VerifyOtpResponse> {

    const req = new SilverNonEmployeesLogonRequestBuilder(SilverControllerService.VerifyOtpUsingPostPath, 'post');
    if (params) {
      req.body(params.body, 'application/json');
    }

    const sendReq = req.build({
      responseType: 'json',
      accept: 'application/json'
    });

    return this.http.request<any>(
      sendReq.method,
      sendReq.url,
      sendReq.body,
      sendReq.options
    ).pipe(
      map(r => {
        return r as VerifyOtpResponse;
      })
    );
  }

  /**
   * OTP verification for client registration.
   *
   *
   *
   * This method provides access to only to the response body (usually preferred).
   * For request customization, `verifyOtpUsingPost$Response()` use instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyOtpUsingPost(params: {
  
    /**
     * verifyOtpRequest
     */
    body: VerifyOtpRequest
  }): Observable<VerifyOtpResponse> {

    return this.verifyOtpUsingPost$Response(params).pipe(
      map(r => r as VerifyOtpResponse)
    );
  }

}
